import React from 'react';
import {connect} from 'react-redux';
import propTypes from 'prop-types';
import lang from '../../constants/Languages.js';
import {Link} from 'react-router-dom';

const HeadingsTitleSearchResultsDetail = ({ clang, headingsPath, recordsNumber, searchKey}) => {
    const mainHeading = headingsPath[headingsPath.length - 1];
    const subHeadings = headingsPath.slice(0, -1);

    const getMainHeadingLabelhighlighted = () => {
        if (mainHeading.label.toLowerCase().indexOf(searchKey.toLowerCase()) === -1 || searchKey === '') {
            return mainHeading.label;
        }

        return mainHeading.label.replace(new RegExp(`${searchKey}`, 'gi'), m => '<span class="highlight">' + m + '</span>');
    }

    return (
        <li className="headings-results__list--inner__item">
            <div>
                <Link to={mainHeading.link} className="headings-results__list--inner__link" title={mainHeading.label} dangerouslySetInnerHTML={{__html: getMainHeadingLabelhighlighted() }}>
                </Link>
                <span className="headings-results__list--inner__count">({recordsNumber})</span>
            </div>

            <ul className="headings-results__list--nested">
                <div className="headings-results__list--inner__separator">{lang[clang].characteristics.in}:</div>
                {subHeadings.map((path, index) =>
                    <li className="headings-results__list--nested__item" key={index}>
                        <div>
                            <Link to={path.link} className="headings-results__list--nested__link" title={lang[clang].field_types[path.label] ? lang[clang].field_types[path.label] : path.label}>
                                {lang[clang].field_types[path.label] ? lang[clang].field_types[path.label] : path.label}
                            </Link>
                        </div>

                        {subHeadings.length - 1 !== index &&
                            <div className="headings-results__list--nested__separator">></div>}
                    </li>)}
            </ul>
        </li>
    );
};

HeadingsTitleSearchResultsDetail.propTypes = {
    clang: propTypes.string.isRequired
};

const mapStateToProps = state => ({
    clang: state.language.currentLanguage
});

export default connect(mapStateToProps)(HeadingsTitleSearchResultsDetail);



// WEBPACK FOOTER //
// ./src/components/characteristics/HeadingsTitleSearchResultsDetail.js